import { render, staticRenderFns } from "./new-item-form.vue?vue&type=template&id=0a48651e&scoped=true&"
import script from "./new-item-form.vue?vue&type=script&lang=js&"
export * from "./new-item-form.vue?vue&type=script&lang=js&"
import style0 from "./new-item-form.vue?vue&type=style&index=0&id=0a48651e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48651e",
  null
  
)

export default component.exports